// Fenêtre modale commune aux formulaires des achats et des travaux (lot L4-C) : titre, description,
// bouton d'envoi avec chargement, erreur du serveur affichée telle quelle.
import { Bandeau, Bouton, Dialogue } from '@cc/ui';
import type { ReactNode } from 'react';

export function Fenetre({ titre, description, libelle, enCours, onFermer, onValider, erreur, children }: { titre: string; description: string; libelle: string; enCours: boolean; onFermer: () => void; onValider: () => void; erreur: string | null; children: ReactNode }) {
  return (
    <Dialogue ouvert titre={titre} description={description} onFermer={onFermer} actions={<><Bouton variante="secondaire" onClick={onFermer}>Annuler</Bouton><Bouton variante="principal" chargement={enCours} onClick={onValider}>{libelle}</Bouton></>}>
      {children}
      {erreur ? <Bandeau type="erreur">{erreur}</Bandeau> : null}
    </Dialogue>
  );
}
